// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zfeGtS9EEYFrbXu_jesK {
  background-color: #fff;
  width: 100%;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
}
.kPKbzNLMfV1x29px5STw {
  max-width: 450px;
  min-width: 320px;
  height: 150px;
  padding: 20px;
  box-shadow: 1px 2px 7px 1px #bbb;
  border-radius: 8px;
  position: relative;
  display: inline-block;
}
.M6WHJE4BJPgBt16LePym {
  font-size: 28px;
  font-weight: bold;
}
.iDBZByIkM0aDNeQ0fE7V {
  font-size: 24px;
}
.Bezfqt8X2SEV3jGpTNz9 {
  position: absolute;
  right: 5px;
  top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Workspace/MaterialBalance/styles.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;AACF;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAAF;AAGA;EACE,eAAA;EACA,iBAAA;AADF;AAIA;EACE,eAAA;AAFF;AAKA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAHF","sourcesContent":[".listContainer {\n  background-color: #fff;\n  width: 100%;\n  padding: 20px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 20px;\n}\n\n.cardContainer {\n  max-width: 450px;\n  min-width: 320px;\n  height: 150px;\n  padding: 20px;\n  box-shadow: 1px 2px 7px 1px #bbb;\n  border-radius: 8px;\n  position: relative;\n  display: inline-block;\n}\n\n.cardName {\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.cardDescription {\n  font-size: 24px;\n}\n\n.cardActions {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listContainer": `zfeGtS9EEYFrbXu_jesK`,
	"cardContainer": `kPKbzNLMfV1x29px5STw`,
	"cardName": `M6WHJE4BJPgBt16LePym`,
	"cardDescription": `iDBZByIkM0aDNeQ0fE7V`,
	"cardActions": `Bezfqt8X2SEV3jGpTNz9`
};
export default ___CSS_LOADER_EXPORT___;
